import type { MedicalAidValidationResponse } from '@quromedical/models';
import { compact } from '@quromedical/utils';
import { getDisplayName } from 'core/person';
import { type Field, FormCard, type RowConfig } from 'design-system';
import type React from 'react';
import { strings } from 'strings';

interface PatientSelectionCardProps {
  inactiveMembers: MedicalAidValidationResponse;
}

const createInactiveMembersRows = (
  inactiveMembers: MedicalAidValidationResponse,
): RowConfig[] => {
  const names = inactiveMembers.map((i) => getDisplayName(i.general));

  const reasons = inactiveMembers.map((i) => i.medicalAidMembership?.status);

  const nameFields: Field = {
    type: 'list',
    label: strings.CardLabelInactiveMembers,
    display: compact(names),
  };

  const reasonFields: Field = {
    type: 'list',
    label: strings.CardLabelInactiveMedicalAidReason,
    display: compact(reasons),
  };

  const inactiveMemberFields: RowConfig[] = [
    {
      icon: 'warning',
      fields: [nameFields, reasonFields],
    },
  ];

  return inactiveMemberFields;
};

export const InactiveMembersCard: React.FC<PatientSelectionCardProps> = ({
  inactiveMembers,
}) => {
  const rows = createInactiveMembersRows(inactiveMembers);

  return (
    <FormCard
      cardColor="status-warning"
      showIcons={true}
      title={strings.CardTitleInactiveMedicalAidMembers}
      rows={rows}
    />
  );
};
